
"use client";

import styles from "./SkillsCard.module.scss";
import Carousel from '../../molecules/CustomCarousels/Carousel';

export default function SkillsCard({ learningOutcome }: any) {


  if (!learningOutcome) return null;

  return (
    <div className={styles.wrapper}>
      <h2 className={styles.heading}>{learningOutcome?.Heading}</h2>
      <div className={styles.carousel_container}>
      <Carousel
          className={styles.carousel}
          config={{
            slidesPerView: 3,
            spaceBetween: 0,
            autoplay: {
              status: true,
              delay: 3000
            },
            navigation: {
              status: false,
              nextEl: styles.nextBtn,
              prevEl: styles.prevBtn
            },
            pagination: {
              status: false,
              clickable: true
            },
            breakpoints: {
              320: {
                slidesPerView: 1.1,
                spaceBetween: 20
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 10
              },
              1024: {
                slidesPerView: 3,
                spaceBetween: 20
              }
            }
          }}
      >
        {learningOutcome?.Imagelist?.map((item, index) => (
           <div key={index} className={styles.card_container}>
          <div  className={styles.cards}>
            <div className={styles.iconBox}>
              <img
                src={`${item?.rightImage?.url}`}
                alt={item?.Title}
              
              />
            </div>
            <div>
              <h3 className={styles.title}>{item?.Title}</h3>
              <p className={styles.desc}>{item?.Subtitle}</p>
            </div>
          </div>
          </div>
        ))}
      </Carousel>
    </div>
    </div>
  );
}








